// Difficulty options (AI). iconColor = semantic difficulty color.
export const DIFFICULTY = [
  { id: "easy",   level: 1, iconColor: "var(--color-success, #16a34a)",   name: "Easy",   desc: "Crowd-pleasers everyone can answer." },
  { id: "medium", level: 2, iconColor: "var(--color-gold-deep, #e7ae02)", name: "Medium", desc: "A fair fight for most groups." },
  { id: "hard",   level: 3, iconColor: "#e0556b",                          name: "Hard",   desc: "For the know-it-alls in the room." },
];

// Length options (AI). Copy matches the existing backend config (Short = 5 cats).
export const AI_LENGTH = [
  { id: "short",  name: "Short",    meta: "~15 min", detailLines: ["1 round + Final round", "5 categories"] },
  { id: "normal", name: "Standard", meta: "~30 min", detailLines: ["2 rounds + Final round", "5 categories"] },
  { id: "epic",   name: "Epic",     meta: "~45 min", detailLines: ["3 rounds + Final round", "6 categories"] },
];

// Length options (manual). Matches ManualCreate.buildGameOptions mapping.
export const MANUAL_LENGTH = [
  { id: "short",    name: "Short",    meta: "1 round",  detailLines: ["5 categories per round", "5 questions each"] },
  { id: "standard", name: "Standard", meta: "2 rounds", detailLines: ["6 categories per round", "5 questions each"] },
  { id: "long",     name: "Long",     meta: "3 rounds", detailLines: ["7 categories per round", "5 questions each"] },
];
